import { InvoiceState } from '../../features/invoices/Invoices.const';
import { SortOrder } from '../../types';
import { AsyncData } from '../../types/asyncData';

export interface Invoice {
  id: string;
  invoiceUrl?: string;
  amount: number;
  debt: number | null;
  amountPaid: number | null;
  invoiceDueDate: string;
  whencreated: string;
  paidOn: string | null;
  isPaidAfterPastDue: boolean | null;
  projectName?: string;
}
export interface InvoiceInitialState {
  invoices: AsyncData<Invoice[]>;
  areFiltersApplied: boolean;
  filterBy: {
    invoiceState: InvoiceState;
    projectNames: string[];
    showZeroInvoices: boolean;
  };
  isFilterOpen: boolean;
  sort: {
    by: SortInvoicesBy;
    order: SortOrder;
  }[];
}

export enum SortInvoicesBy {
  INVOICE_ID = 'invoiceId',
  PROJECT_NAME = 'projectName',
  AMOUNT = 'amount',
  DEBT = 'debt',
  AMOUNT_PAID = 'amountPaid',
  INVOICE_DUE_DATE = 'invoiceDueDate',
  INVOICE_SENT = 'whencreated',
  PAID_ON = 'paidOn',
  OVERDUE = 'isPaidAfterPastDue',
}

export interface InvoicesSortPayloadType {
  newSortBy: SortInvoicesBy;
}
